import { forwardRef, memo } from 'react';
import HBAutosizeTextArea, {
    HBAutosizeTextAreaProps
} from '../HBAutosizeTextArea/HBAutosizeTextArea';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import React from 'react';

export interface HBAutosizeTextAreaFieldProps
    extends HBBaseFormFieldProps,
        Omit<HBAutosizeTextAreaProps, 'size' | 'label' | 'width'> {
    /** HTML `id` for the field; used as the `<label htmlFor>` target. Required. */
    id: string;
    /** @deprecated Temporary flag for DS Next styling. Will be removed post-migration. */
    isDSNext?: boolean;
}

const HBAutosizeTextAreaField = forwardRef<
    HTMLTextAreaElement,
    HBAutosizeTextAreaFieldProps
>(({ size = 'sm', labelSize = 'sm', ...props }, ref) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={labelSize}>
            <HBAutosizeTextArea
                {...inputProps}
                ref={ref}
                size={size}
                required={fieldProps.required}
            />
        </HBBaseFormField>
    );
});

export default memo(HBAutosizeTextAreaField);
